import script from "./summernote.vue?vue&type=script&setup=true&lang=js"
export * from "./summernote.vue?vue&type=script&setup=true&lang=js"

import "./summernote.vue?vue&type=style&index=0&id=85e3034c&lang=css"

const __exports__ = script;

export default __exports__